import { ViewContainer } from '../../../tabview/ViewContainer';
import { colors, s16 } from '@ardoq/design-tokens';
import { SIMPLE_GRAPH_BACKGROUND_COLOR_CSS_VARIABLE } from './SimpleGraphView';
import dottedBackground from '../dotted-bg-darker.svg';
import styled from 'styled-components';
import React from 'react';

export const SimpleGraphContainerWithGreyBackground = styled(ViewContainer)<{
  $margin?: React.CSSProperties['margin'];
  $backgroundSize?: React.CSSProperties['backgroundSize'];
}>`
  height: 100%;
  margin: ${({ $margin }) =>
    $margin !== undefined
      ? $margin
      : s16}; /* creates more pleasant dotted-background effect */
  /*
    If you need non-white background for the graph, you need to set background-color
    and this variable to the same value so that the label background matches the graph background.
   */

  ${SIMPLE_GRAPH_BACKGROUND_COLOR_CSS_VARIABLE}: ${colors.grey50};
  background-color: ${colors.grey50};
  /* To ensure inline SVGs work in Vite, we need to wrap the URL in double quotes. */
  /* prettier-ignore */
  background-image: url("${dottedBackground}");
  background-size: ${({ $backgroundSize }) => $backgroundSize ?? '20px'};
  background-repeat: repeat;
`;
